import { useVariant } from '../context/VariantContext';

export default function Flow() {
  const { flow } = useVariant();
  return (
    <section className="lp__flow" id="flow">
      <p className="lp__flow-en">Flow</p>
      <h2 className="lp__flow-heading">ご利用までの流れ</h2>
      <div className="lp__flow-steps">
        {flow.steps.map((step, i) => (
          <div className="lp__flow-step" key={step.number}>
            <div className="lp__flow-step__number">{step.number}</div>
            {i < flow.steps.length - 1 && <div className="lp__flow-step__line" />}
            <div className="lp__flow-step__body">
              <h3 className="lp__flow-step__title">{step.title}</h3>
              <p className="lp__flow-step__desc">
                {step.description}
                {step.link && (
                  <>
                    <br />
                    <a className="lp__flow-step__link" href={step.link.href}>{step.link.text}</a>
                  </>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
